/* /plans interactions without React hydration, server actions, or new trackers. */
(() => {
	const root = document.querySelector('[data-v3]');
	if (!root || root.dataset.ypUnifiedRuntimeReady === 'true') return;
	root.dataset.ypUnifiedRuntimeReady = 'true';
	const analytics = window.YPAnalytics;
	const currentMarket = root.dataset.ypMarket || 'AE';
	const currentPage = root.dataset.ypPage || 'tiers';
	const currentLanguage = document.documentElement.lang === 'ar' ? 'ar' : 'en';
	const isUnifiedLanding = root.dataset.ypUnified === 'true' && ['home','test','sixmonths'].includes(currentPage);
	const buyLabel = /^unified_buy_(basic|premium|standard)_(1m|6m|12m)_(standard|tabby|apple_pay|google_pay|shop_pay|paypal|amazon_pay)$/;
	const interactionLabel = /^unified_(?:final_get_yango_play|header_logo|faq_(?:when|country|gift|existing|payment|refund|broken)_(?:open|close)|language_(?:en_to_ar|ar_to_en)|title_(?:batal_al_alam|roses_and_chocolate|champions_league|the_gang_of_el_max|the_silk_kingdom)_(?:open|close|cta)|footer_(?:new_releases|must_watch|forever_favorites|recently_added|binge_watch|only_on_yango_play|made_in_egypt|best_selections|yasmina|music|activate_promo_code|contact_support|agreement|facebook|instagram|tiktok)|localization_submit_(?:ae|kw|qa)|market_menu_(?:open|close)|market_change_(?:ae|kw|qa)_to_(?:ae|kw|qa))$/;
	if (isUnifiedLanding) window.YPUnifiedTracking = {
		trackButtonClick: (label, onTracked) => {
			let completed = false;
			let fallback;
			const finish = () => {
				if (completed) return;
				completed = true;
				if (fallback !== undefined) clearTimeout(fallback);
				if (typeof onTracked === 'function') onTracked();
			};
			if (typeof label !== 'string' || (!interactionLabel.test(label) && !buyLabel.test(label))) { finish(); return; }
			analytics?.trackButtonClick(label);
			// Reuse the already configured GA4 destination. The live GTM mapper
			// knows legacy labels only; consent and loader readiness must hold now.
			try {
				const pagePath = window.location.pathname;
				const privacy = window.Shopify?.customerPrivacy;
				const matchesSurface = currentPage === 'sixmonths' ? /^\/(?:[a-z]{2}(?:-[A-Z]{2})?\/)?pages\/6months\/?$/.test(pagePath) : currentPage === 'home'
					? /^\/(?:[a-z]{2}(?:-[A-Z]{2})?\/?)?$/.test(pagePath)
					: /^\/(?:[a-z]{2}(?:-[A-Z]{2})?\/)?pages\/test\/?$/.test(pagePath);
				if (!matchesSurface
					|| window.IS_PROD !== true || window.YPGtmLoaded !== true || typeof window.gtag !== 'function'
					|| privacy?.analyticsProcessingAllowed() !== true || privacy?.marketingAllowed() !== true
					|| !['AE','KW','QA'].includes(currentMarket)) { finish(); return; }
				const parameters = {send_to: 'G-JPLRNG5182', event_label: label, market: currentMarket, locale: currentLanguage, page_path: pagePath, page_surface: currentPage};
				const buy = label.match(buyLabel);
				if (buy) {
					parameters.tier = buy[1].toUpperCase();
					parameters.duration = buy[2].toUpperCase();
					parameters[['standard','tabby'].includes(buy[3]) ? 'checkout_method' : 'payment_method'] = buy[3];
				}
				if (typeof onTracked === 'function') {
					parameters.event_callback = finish;
					parameters.event_timeout = 600;
					// Install the independent fallback before gtag: it may throw or
					// stay queued, and neither case may trap a navigation.
					fallback = setTimeout(finish, 600);
				}
				window.gtag('event', 'yp_button_click', parameters);
			} catch { finish(); /* Missing or revoked consent must not interrupt interaction. */ }
		},
	};
	const trackInteraction = (label, onTracked) => {
		if (isUnifiedLanding) window.YPUnifiedTracking.trackButtonClick(label, onTracked);
		else if (typeof onTracked === 'function') onTracked();
	};
	const nativeCountry = document.querySelector('[data-yp-current-country]')?.dataset.ypCurrentCountry;
	const setReturnTo = (form, value) => form.querySelectorAll('[name="return_to"]').forEach(input => { input.value = value; });
	const resumedCountryForms = new WeakSet();
	document.querySelectorAll('.yp-express-country-form').forEach(form => form.addEventListener('submit', event => {
		setReturnTo(form, window.location.pathname + window.location.search);
		if (resumedCountryForms.has(form)) { resumedCountryForms.delete(form); return; }
		const market = form.elements.namedItem('country_code')?.value;
		if (isUnifiedLanding && !event.defaultPrevented && ['AE','KW','QA'].includes(market)) {
			event.preventDefault();
			const submitter = event.submitter;
			trackInteraction('unified_localization_submit_' + market.toLowerCase(), () => {
				// Even an immediate completion must leave this submit dispatch:
				// browsers ignore a reentrant requestSubmit on the same form.
				setTimeout(() => {
					resumedCountryForms.add(form);
					form.requestSubmit(submitter || undefined);
				}, 0);
			});
		}
	}));
	const selectLocale = (market, lang) => {
		try { localStorage.setItem('v3-lang', lang); } catch {}
		const url = new URL(window.location.href);
		if (url.searchParams.has('market') && ['home','plans','tiers','test','sixmonths'].includes(currentPage)) url.searchParams.set('market', market);
		url.searchParams.set('view', 'yp-' + currentPage + (market === 'AE' ? '' : '-' + market.toLowerCase()) + (lang === 'ar' ? '-ar' : ''));
		const form = document.getElementById('yp-express-localization');
		if (!form) return;
		form.elements.namedItem('country_code').value = currentPage === 'welcome' ? (nativeCountry || market) : market;
		setReturnTo(form, url.pathname + url.search);
		form.requestSubmit();
	};
	try {
		const params = new URLSearchParams(window.location.search);
		const storedLanguage = localStorage.getItem('v3-lang');
		const language = !params.has('view') && ['en','ar'].includes(storedLanguage) ? storedLanguage : currentLanguage;
		const requestedMarket = params.get('market')?.toUpperCase();
		const market = ['home','plans','tiers','test','sixmonths'].includes(currentPage) && ['AE','KW','QA'].includes(requestedMarket) ? requestedMarket : currentMarket;
		if (language !== currentLanguage || market !== currentMarket) { selectLocale(market, language); return; }
		localStorage.setItem('v3-lang', currentLanguage);
	} catch {}
	// A shared regional link must set the same native buyer country as the menu.
	// Attempt once per destination; if cookies/storage are blocked, keep the
	// visible localization fallback available instead of creating a reload loop.
	try {
		const country = document.querySelector('[data-yp-current-country]')?.dataset.ypCurrentCountry;
		const key = 'yp-country-sync';
		if (currentPage !== 'welcome' && country && country !== currentMarket) {
			if (sessionStorage.getItem(key) !== currentMarket) {
				sessionStorage.setItem(key, currentMarket);
				selectLocale(currentMarket, currentLanguage);
				return;
			}
		} else {
			sessionStorage.removeItem(key);
		}
	} catch {
		// The explicit country form remains usable without browser storage.
	}
	// Shopify inserts its unbranded button asynchronously. Change only the idle
	// label in its exposed light DOM; retain the native element and click handler.
	// Wallet buttons, their shadow DOM and processing/error labels stay untouched.
	root.querySelectorAll('.yp-express-payment[data-buy-label]').forEach(payment => {
		const label = payment.dataset.buyLabel;
		const brandBuyLabel = () => {
			const button = payment.querySelector('shopify-buy-it-now-button[slot="button"] .shopify-payment-button__button--unbranded');
			if (!button || button.disabled || button.getAttribute('aria-busy') === 'true') return;
			if (!['Buy it now', 'اشتر الآن', 'اشترِ الآن'].includes(button.textContent.trim())) return;
			button.textContent = label;
		};
		brandBuyLabel();
		new MutationObserver(brandBuyLabel).observe(payment, {childList: true, subtree: true, characterData: true});
	});
	const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
	const scrollToCatalog = () => (document.getElementById('catalog') || document.getElementById('tabby-plans') || document.getElementById('long-plans'))?.scrollIntoView({behavior: reduced.matches ? 'auto' : 'smooth', block: 'start'});
	const header = root.querySelector('.v3-header');
	const updateHeader = () => header?.setAttribute('data-scrolled', String(window.scrollY > 8));
	window.addEventListener('scroll', updateHeader, {passive: true});
	updateHeader();
	const sections = root.querySelectorAll('.v4-hero, .v4-catalog, .v3-killer-usp, .v3-how, .v3-top5, .v3-reviews, .v3-faq, .v3-final, .v3-welcome, .tabby-hero, .tabby-catalog, .tabby-savings, .tabby-final, .long-plans-hero, .long-plans-savings, .long-plans-final');
	if ('IntersectionObserver' in window && !reduced.matches) {
		const observer = new IntersectionObserver(entries => entries.forEach(entry => {
			if (entry.isIntersecting) { entry.target.dataset.revealed = 'true'; observer.unobserve(entry.target); }
		}), {rootMargin: '0px 0px -10% 0px'});
		sections.forEach(section => { section.dataset.revealed = 'false'; section.dataset.revealReady = 'true'; observer.observe(section); });
	}
	root.querySelectorAll('.v4-hero-cta > button, .v3-final-cta button, .tabby-hero button, .tabby-final button, .long-plans-hero button, .long-plans-final button').forEach(button => button.addEventListener('click', () => {
		const label = button.closest('.v4-hero') ? 'v4_hero_get_gift_card'
			: button.closest('.tabby-hero') ? 'tabby_hero_choose_plan'
			: button.closest('.tabby-final') ? 'tabby_final_choose_plan'
			: button.closest('.long-plans-hero') ? 'long_plans_hero_get_subscription'
			: button.closest('.long-plans-final') ? 'long_plans_final_get_yango_play' : null;
		if (label) analytics?.trackButtonClick(label);
		if (button.closest('.v3-final-cta')) trackInteraction('unified_final_get_yango_play');
		scrollToCatalog();
	}));
	root.querySelectorAll('.v3-faq-summary').forEach(button => button.addEventListener('click', () => {
		const open = button.getAttribute('aria-expanded') !== 'true';
		button.setAttribute('aria-expanded', String(open));
		button.closest('.v3-faq-item').dataset.open = String(open);
		document.getElementById(button.getAttribute('aria-controls'))?.setAttribute('aria-hidden', String(!open));
		const key = button.getAttribute('aria-controls')?.replace('v3-faq-panel-', '');
		if (['when','country','gift','existing','payment','refund','broken'].includes(key)) trackInteraction('unified_faq_' + key + (open ? '_open' : '_close'));
	}));
	root.querySelectorAll('[data-yp-lang-switch] input').forEach(input => input.addEventListener('change', () => {
		if (!['en','ar'].includes(input.value) || input.value === currentLanguage) return;
		const lang = input.value;
		trackInteraction('unified_language_' + currentLanguage + '_to_' + lang, () => selectLocale(currentMarket, lang));
	}));
	let activeDialog = root.querySelector('.v3-title-dialog');
	root.querySelectorAll('.v3-top5-link').forEach((button, index) => button.addEventListener('click', () => {
		const template = document.querySelector(`template[data-yp-title-template="${index}"]`);
		if (!template) return;
		const next = template.content.firstElementChild.cloneNode(true);
		activeDialog.replaceWith(next); activeDialog = next;
		const titleKey = ['batal_al_alam','roses_and_chocolate','champions_league','the_gang_of_el_max','the_silk_kingdom'][index];
		let closedByCta = false;
		next.addEventListener('close', () => {
			if (titleKey && !closedByCta) trackInteraction('unified_title_' + titleKey + '_close');
		}, {once: true});
		next.querySelector('.v3-title-dialog-close button').addEventListener('click', () => next.close());
		next.querySelector('.v3-title-dialog-cta button').addEventListener('click', () => {
			closedByCta = true;
			if (titleKey) trackInteraction('unified_title_' + titleKey + '_cta');
			next.close(); scrollToCatalog();
		});
		next.addEventListener('mousedown', event => {if (event.target === next) next.close();});
		next.showModal();
		if (titleKey) trackInteraction('unified_title_' + titleKey + '_open');
	}));
	const trackLink = (link, label) => link.addEventListener('click', event => {
		const target = link.getAttribute('target');
		if (!isUnifiedLanding || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey
			|| (target && target !== '_self') || link.hasAttribute('download')) {
			trackInteraction(label);
			return;
		}
		event.preventDefault();
		const destination = new URL(link.getAttribute('href'), window.location.href).href;
		trackInteraction(label, () => window.location.assign(destination));
	});
	root.querySelectorAll('.v3-header [data-yp-logo]').forEach(link => trackLink(link, 'unified_header_logo'));
	const footerLinks = {
		'https://play.yango.com/movies/selection/2507': 'new_releases',
		'https://play.yango.com/movies/selection/2668': 'must_watch',
		'https://play.yango.com/movies/selection/3329': 'forever_favorites',
		'https://play.yango.com/movies/selection/2710': 'recently_added',
		'https://play.yango.com/movies/selection/3209': 'binge_watch',
		'https://play.yango.com/movies/selection/3464': 'only_on_yango_play',
		'https://play.yango.com/movies/selection/2513': 'made_in_egypt',
		'https://play.yango.com/special/best-selections': 'best_selections',
		'https://yasmina.yango.com': 'yasmina',
		'https://music.yango.com': 'music',
		'https://play.yango.com/en/gift': 'activate_promo_code',
		'https://play.yango.com/support/en/contact-us/': 'contact_support',
		'https://yango.com/legal/uae_yango_play_conditions/': 'agreement',
		'https://www.facebook.com/yangoplay': 'facebook',
		'https://www.instagram.com/yangoplay': 'instagram',
		'https://www.tiktok.com/@yangoplay': 'tiktok',
	};
	root.querySelectorAll('.v3-footer a').forEach(link => {
		const key = footerLinks[link.getAttribute('href')];
		if (key) trackLink(link, 'unified_footer_' + key);
	});
	const market = root.querySelector('.market-switcher');
	if (market) {
		const trigger = market.querySelector('.market-switcher-trigger');
		const list = market.querySelector('.market-switcher-listbox');
		const options = [...market.querySelectorAll('.market-switcher-option')];
		const setOpen = (open, focus = false) => {
			if (open) market.dataset.open = 'true'; else delete market.dataset.open;
			trigger.setAttribute('aria-expanded', String(open)); list.setAttribute('aria-hidden', String(!open));
			options.forEach(option => option.tabIndex = open ? 0 : -1);
			if (focus) (open ? (options.find(option => option.getAttribute('aria-selected') === 'true') || options[0]) : trigger).focus();
		};
		trigger.addEventListener('click', event => {
			const open = !market.dataset.open;
			setOpen(open, event.detail === 0);
			trackInteraction('unified_market_menu_' + (open ? 'open' : 'close'));
		});
		trigger.addEventListener('keydown', event => {
			if (['ArrowDown','ArrowUp'].includes(event.key)) {
				event.preventDefault();
				const wasOpen = Boolean(market.dataset.open);
				setOpen(true,true);
				if (!wasOpen) trackInteraction('unified_market_menu_open');
			}
		});
		document.addEventListener('pointerdown', event => {if (!market.contains(event.target)) setOpen(false);});
		market.addEventListener('keydown', event => {if(event.key === 'Escape') {event.preventDefault();setOpen(false,true);}});
		options.forEach((option,index) => {
			option.addEventListener('click', () => {
				setOpen(false,true);
				const selectedMarket = ['AE','KW','QA'][index];
				if (selectedMarket !== currentMarket) {
					analytics?.trackMarketChange(currentMarket, selectedMarket);
					trackInteraction('unified_market_change_' + currentMarket.toLowerCase() + '_to_' + selectedMarket.toLowerCase(), () => selectLocale(selectedMarket, currentLanguage));
				}
			});
			option.addEventListener('keydown', event => {
				let target;
				if(event.key === 'ArrowDown') target=(index+1)%options.length;
				if(event.key === 'ArrowUp') target=(index+options.length-1)%options.length;
				if(event.key === 'Home') target=0;
				if(event.key === 'End') target=options.length-1;
				if(target !== undefined){event.preventDefault();options[target].focus();}
				if(event.key === 'Tab') setOpen(false);
			});
		});
	}
})();
